import {BaseCriteriaModel} from '../base-criteria.model';
import {Optional} from 'typescript-optional';

export class MerchantTxnReportQueryCriteriaClass extends BaseCriteriaModel {
    merchant_code?: Optional<string> = Optional.empty();
    merchant_guid?: Optional<string> = Optional.empty();
    rate_card_line_guid?: Optional<string> = Optional.empty();
    contract_rate_guid?: Optional<string> = Optional.empty();
    payment_channel_guid?: Optional<string> = Optional.empty();

    created_after?: Optional<string> = Optional.empty();
    created_before?: Optional<string> = Optional.empty();
    updated_after?: Optional<string> = Optional.empty();
    updated_before?: Optional<string> = Optional.empty();
    created_by_subject_guid?: Optional<string> = Optional.empty();
  }

  export class MerchantTxnReportCriteriaModelQuery{
      query = '';
      constructor(merchantTxnReportCriteriaModel:MerchantTxnReportQueryCriteriaClass){
          console.log("merchantTxnReportCriteriaModel",merchantTxnReportCriteriaModel);

          if(!merchantTxnReportCriteriaModel){
            return;
      }

      this.query += merchantTxnReportCriteriaModel.merchant_code.filter(x => x !== '').map(x => '&merchant_code=' + x).orElse('');
      this.query += merchantTxnReportCriteriaModel.merchant_guid.filter(x => x !== '').map(x => '&merchant_guid=' + x).orElse('');
      this.query += merchantTxnReportCriteriaModel.rate_card_line_guid.filter(x => x !== '').map(x => '&rate_card_line_guid=' + x).orElse('');
      this.query += merchantTxnReportCriteriaModel.contract_rate_guid.filter(x => x !== '').map(x => '&contract_rate_guid=' + x).orElse('');
      this.query += merchantTxnReportCriteriaModel.payment_channel_guid.filter(x => x !== '').map(x => '&payment_channel_guid=' + x).orElse('');
      this.query += merchantTxnReportCriteriaModel.created_after.filter(x => x !== '').map(x => '&created_after=' + x).orElse('');
      this.query += merchantTxnReportCriteriaModel.created_before.filter(x => x !== null).map(x => '&created_before=' + x).orElse('');
      this.query += merchantTxnReportCriteriaModel.updated_after.filter(x => x !== '').map(x => '&updated_after=' + x).orElse('');
      this.query += merchantTxnReportCriteriaModel.updated_before.filter(x => x !== null).map(x => '&updated_before=' + x).orElse('');
      this.query += merchantTxnReportCriteriaModel.created_by_subject_guid.filter(x => x !== null).map(x => '&created_by_subject_guid=' + x).orElse('');

      this.query += '&status=' + merchantTxnReportCriteriaModel.status;
      this.query += '&orderBy=' + merchantTxnReportCriteriaModel.orderBy;
      this.query += '&order=' + merchantTxnReportCriteriaModel.order;
      this.query += '&offset=' + merchantTxnReportCriteriaModel.offset + '&limit=' + merchantTxnReportCriteriaModel.limit;
      }
  }